import { render, staticRenderFns } from "./buscador.vue?vue&type=template&id=59d71934&"
import script from "./buscador.vue?vue&type=script&lang=js&"
export * from "./buscador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports